import { DateTimeFormatter } from '../../../formatters';
import { FlightPreDepContextMenuData, FlightPreDepTooltipData } from '../../../services/map-interaction-service';

export function FlightPreDepTooltip(props: { info: FlightPreDepTooltipData }) {
    const context = props.info;
    return (
        <div style={{ fontSize: 12, width: 200 }}>
            <PreDepartureItem name="Planned" item={context.flights.planned} />
            <PreDepartureItem name="Scheduled" item={context.flights.scheduled} />
        </div>
    );
}

function PreDepartureItem(props: {
    item: FlightPreDepContextMenuData['flights']['planned'];
    name: string;
    onClick?: (id: number) => void;
}) {
    if (!props.item.some((x) => x.items.length > 0)) {
        return <></>;
    }

    return (
        <div>
            <div className="text-center bg-color p-1" style={{ fontSize: '1.15em' }}>
                {props.item.map((x) => x.airport).join('/')} {props.name}
            </div>
            {props.item.map((x, i) => (
                <div key={i} className="px-2">
                    {x.items.map((x) => (
                        <div className="flex-grow-1 d-flex gap-2 py-1" key={x.id}>
                            <div style={{ width: '35%' }} className="text-start">
                                {x.acid}
                            </div>
                            <div style={{ width: '40%' }} className="text-start">
                                {DateTimeFormatter.formatTime(x.depTime)}
                            </div>
                            <div style={{ width: '25%' }} className="text-start">
                                {x.acType || '-'}
                            </div>
                        </div>
                    ))}
                </div>
            ))}
        </div>
    );
}
